import React, { useEffect, useState } from "react"
import instacartDiscountIcon from "../../../../images/instacart_discount_icon.svg"
import phoneIcon from "../../../../images/phone-icon.svg"
import calendarIcon from "../../../../images/calendar-icon.svg"
import { connect } from "react-redux"
import {
  Button,
  Checkbox,
  Divider,
  Image,
  Modal,
  Form,
  FormField,
  Message,
  Card
} from "semantic-ui-react"
import { routerPaths } from "../../../../v1/constants/paths"
import { Link, Redirect } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { isDesktop } from "react-device-detect"
import LoadingComponent from "../../../../v1/components/LoadingComponent"
import { createOrder, updateOrder } from "../../../../v1/actions/orders"
import { me, optInForMarketing } from "../../../../v1/actions/user"
import {
  gaJSON,
  logPurchase,
  orderBookedEvents,
  trackFirebaseAnalytics
} from "../../../../shared_component/utils/googleAnalyticsHelpers"
import PaymentMethod from "../../../../v1/components/PaymentMethods/PaymentMethod"
import caShortLogo from "../../../../images/ca-orange-short.svg"
import CloseIcon from "../../../../images/close-icon.svg"
import AffirmLogo from "../../../../images/affirm-logo.svg"
import { EBAY, INSTACART, INSTACART_CANADA } from "../../../../v1/constants/affiliations"
import ReviewServices from "./ReviewServices"
import AddPaymentDetails from "../AddPaymentDetails"
import { getUpdatedCart, isEbayTireOrder } from "../../../../v1/helpers/orderHelpers"
import InfoIcon from "../../../../images/info-Icon.svg"
import cartWarningLogo from "../../../../images/cartWarningLogo.svg"
import { updateInfo } from "../../../../v1/actions/user"
import callIcon from "../../../../images/call-icon.svg"
import { getSubdomain } from "../../../../v1/components/Config/StylesheetInjector"
import { isEbay, isEbayUser } from "../../../../v1/helpers/affiliationHelpers"
import { formatPhoneNumber } from "../../../utils/formatPhoneNumber"
import { WHEEL_ALIGNMENT } from "../../../../v1/actions/services"
import { withRouter } from "react-router"

const ReviewRequest = ({
  cart,
  vehicle,
  activeVehicle,
  createOrder,
  updateOrder,
  optInForMarketing,
  t,
  user,
  braintreePaymentMethods,
  order,
  updateInfo,
  history
}) => {
  const [orderId, setOrderId] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [customerNote, setCustomerNote] = useState("")
  const [marketingOptIn, setMarketingOptIn] = useState(false)
  const isEbayTireCart = isEbayUser(user) && isEbayTireOrder(cart)
  const [mobileNumber, setMobileNumber] = useState("")
  const [mobileNumberError, setMobileNumberError] = useState("")
  const [showMarketingCheckbox, setShowMarketingCheckbox] = useState(false)
  const isInstacartUser = [INSTACART, INSTACART_CANADA].includes(
    user?.affiliation?.root_reference_id
  )
  const defaultPaymentMethod = braintreePaymentMethods.find((method) => method.isdefault)

  const hasWheelAlignment = cart.order_services.find(
    (service) => service?.reference_id === WHEEL_ALIGNMENT
  )

  useEffect(() => {
    if (user?.cellPhone && user?.cellPhone !== "0000000000") {
      setMobileNumber(formatPhoneNumber(user.cellPhone) || "")
    }
    const userOptedForMarketing = user?.marketing_opt_in || false
    setMarketingOptIn(userOptedForMarketing)
  }, [])

  const handleMobileNumberChange = (e) => {
    const formattedPhoneNumber = formatPhoneNumber(e.target.value)
    setMobileNumber(formattedPhoneNumber)
    const phoneNumber = formattedPhoneNumber.replace(/[^\d]/g, "")
    if (phoneNumber.length === 10) {
      setMobileNumberError("")
    } else {
      setMobileNumberError(t("Please enter a valid phone number."))
    }
  }

  const handleCustomerNote = (e) => {
    setCustomerNote(e.target.value)
  }
  const toggleModal = () => {
    setOpenModal(true)
  }

  const handleMarketingOptIn = async () => {
    setMarketingOptIn(!marketingOptIn)
  }

  useEffect(() => {
    trackFirebaseAnalytics({
      event: gaJSON.checkout_start,
      params: {
        cart_value: cart.estimated_total || 0,
        service_count: cart.order_services.length || 0,
        returning_user: user.total_shop_orders > 0 ? "true" : "false"
      }
    })
  }, [])

  const onSubmit = async () => {
    if (
      hasWheelAlignment &&
      braintreePaymentMethods.length === 0 &&
      cart.payment_type !== "affirm"
    ) {
      history.push({
        pathname: routerPaths.addPayment
      })
      return
    }
    setIsSubmitting(true)
    try {
      const phoneNumber = mobileNumber?.replace(/[^\d]/g, "") || ""
      if (isEbayTireCart && phoneNumber != user.cellPhone) {
        await updateInfo({
          cellPhone: phoneNumber
        })
      }

      const response = order
        ? await updateOrder(cart, order)
        : await createOrder(cart.id, null, customerNote)
      const orderId = response.result ? response.result.id : response
      if (orderId) {
        setOrderId(orderId)
        logPurchase(response.result.currency.toUpperCase(), response.result.total)
        await orderBookedEvents({ response, orderId, activeVehicle })
      }
      if (isEbay()) {
        if (marketingOptIn) {
          await optInForMarketing({
            marketing_opt_in: marketingOptIn
          })
        }
        trackFirebaseAnalytics({
          event: gaJSON.ebay_booking_confirmed,
          params: {
            order_id: orderId,
            cart_value: response.result.total
          }
        })
      }
      trackFirebaseAnalytics({
        event: gaJSON.checkout_complete,
        params: {
          order_id: orderId,
          total_amount: response.result.total,
          payment_method_type: response.result.payment_type
        }
      })
      setIsSubmitting(false)
    } catch (error) {
      setIsSubmitting(false)
      trackFirebaseAnalytics({
        event: gaJSON.EtoB_confirm_service_request_error
      })
    }
  }

  let discountLogo = caShortLogo
  if (isInstacartUser) {
    discountLogo = instacartDiscountIcon
  }

  const showServices = () => {
    if (isEbayTireOrder(cart)) {
      return hasWheelAlignment ? true : false
    }
    return true
  }

  return (
    <>
      {orderId && <Redirect to={`/appointment-confirm/${orderId}`} />}
      {cart && cart.shop ? (
        <div className="review-request-container">
          {isEbayUser
            ? cart?.promotional_discount > 0 && (
                <>
                  <div className="discount-banner">
                    <div className="discount-banner-text">
                      <img className="discount-icon-review" src={discountLogo} />$
                      {cart?.promotions[0]?.discount} {cart?.promotions[0]?.name} {" applied!"}
                    </div>
                  </div>
                  <div className="spacer-20" />
                </>
              )
            : user &&
              user.country !== "ca" &&
              cart &&
              !cart.any_order_service_lacks_price &&
              cart.promotions &&
              cart.promotions.length > 0 && (
                <>
                  <div className="discount-banner">
                    <div className="discount-banner-text">
                      <img className="discount-icon-review" src={discountLogo} />
                      {cart.promotions[0].discount}% {t("oilChangeDiscountApplied")}
                    </div>
                  </div>
                  <div className="spacer-20" />
                </>
              )}
          <div className="heading-size-18" style={{ fontWeight: 700 }}>
            {t("appointmentDetails")}
          </div>
          <div className="spacer-10" />
          <div className="row-space-between">
            <div className="shop-name">{cart.shop ? cart.shop.name : ""}</div>
            <Link
              className="link-text"
              to={routerPaths.shopSelection}
              onClick={() => {
                trackFirebaseAnalytics({
                  event: gaJSON.EtoB_change_selected_shop_review_page
                })
              }}
            >
              {t("change")}
            </Link>
          </div>
          <div className="body-text-16" style={{ color: "#616161" }}>
            {cart.shop ? cart.shop.address_line1 : ""}
          </div>
          <div className="body-text-16" style={{ color: "#616161" }}>
            {cart.shop ? `${cart.shop?.city}, ${cart.shop?.state} - ${cart.shop?.zip}` : ""}
          </div>
          {cart.shop && cart.shop.main_phone_number && (
            <a
              href={isDesktop ? null : "tel:" + cart.shop.main_phone_number}
              className="row-flex-start"
            >
              <img src={phoneIcon} style={{ paddingRight: "5px", height: "16px", width: "16px" }} />
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: 400
                }}
              >
                {cart.shop.main_phone_number}
              </div>
            </a>
          )}
          <div className="spacer-10" />
          <div className="row-space-between">
            <div className="row-flex-start" style={{ color: "#B83614" }}>
              <img
                src={calendarIcon}
                style={{ paddingRight: "5px", height: "16px", width: "16px" }}
              />
              <div style={{ fontWeight: 500, fontSize: "16px" }}>
                {cart.appointment_date_pretty.split(", ")[1]}
                {", "}
                {cart.appointment_date_pretty.split(", ")[2]} |{" "}
                {cart.is_walk_in || false ? "Walk-in only" : cart.appointment_time_pretty}
              </div>
            </div>
            <Link
              className="link-text"
              to={routerPaths.appointment}
              onClick={() => {
                trackFirebaseAnalytics({
                  event: gaJSON.EtoB_change_appointment_review_page
                })
              }}
            >
              {t("change")}
            </Link>
          </div>
          <div className="spacer-10" />
          <div className="row-flex-start" style={{ fontWeight: 400, fontSize: "14px" }}>
            {vehicle.year || ""} {vehicle.make || ""} {vehicle.model || ""}
          </div>

          {isEbayTireCart && (
            <div className="mobile-number">
              {(!user?.cellPhone || user?.cellPhone === "" || user?.cellPhone == "0000000000") && (
                <Card fluid className="mobile-number-info">
                  <Image src={cartWarningLogo} />
                  {t(
                    "Please enter a valid mobile number to continue. We use this number to send important SMS updates about your appointment."
                  )}
                </Card>
              )}
              <Form>
                <FormField error={mobileNumberError.length > 0}>
                  <label className="mobile-label">
                    {t("Mobile Phone Number")} <span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    maxLength={14}
                    placeholder={t("e.g., 307-345-7618")}
                    value={mobileNumber}
                    onChange={handleMobileNumberChange}
                  />
                  {mobileNumberError && (
                    <Message size="mini" negative>
                      {mobileNumberError}
                    </Message>
                  )}
                </FormField>
              </Form>
            </div>
          )}

          {showServices() && (
            <>
              <Divider />
              <ReviewServices handleCustomerNote={handleCustomerNote} customerNote={customerNote} />
              <Divider />

              <div className="payment-method-review">
                <div className="row-space-between">
                  <span className="payment-header">Payment method</span>{" "}
                  <span onClick={() => setOpenModal(true)} className="change-payment">
                    Change
                  </span>
                </div>
                <div className="spacer-20" />
                {cart.payment_type !== "affirm" &&
                  defaultPaymentMethod &&
                  defaultPaymentMethod.token && (
                    <PaymentMethod
                      key={defaultPaymentMethod.token}
                      paymentMethod={defaultPaymentMethod}
                      hideDelete={true}
                      hideSetDefault={true}
                    />
                  )}
                {cart.payment_type == "affirm" && (
                  <div>
                    <Image src={AffirmLogo} alt="Affirm-Logo" />
                  </div>
                )}
              </div>
              <div className="spacer-20" />
              <div className="priced-at-shop-banner teal-color">
                <img className="discount-icon-review" src={InfoIcon} />
                <div className="text-block">
                  <span>{t("onlyChargedWhen")} </span>
                </div>
              </div>
              <Divider />
              <div className="bottom-contact-info review-request-contact-info">
                <div className="margin-right-10">
                  <span className="non-refundable-policy">
                    <strong>{t("bookingDetails:questionOrConcerns")}</strong>
                    <span>{t("bookingDetails:ourSupportTeamToHelp")}</span>
                  </span>
                </div>
                <div className="bottom-support-info">
                  <div className="bottom-support-info-row">
                    <Image src={callIcon} />
                    <span className="margin-left-7">844-923-8473</span>
                  </div>
                </div>
              </div>
            </>
          )}
          {(showMarketingCheckbox ||
            (!(user?.marketing_opt_in || false) && getSubdomain() === EBAY)) && (
            <div style={{ display: "flex", flexDirection: "column", padding: "15px 0" }}>
              <b style={{ textAlign: "left" }}>
                Join over 1 million drivers who trust CarAdvise and get exclusive savings on future
                maintenance
              </b>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "baseline",
                  gap: "5px"
                }}
              >
                <Checkbox
                  checked={marketingOptIn}
                  onChange={handleMarketingOptIn}
                  className="custom-orange-checkbox"
                />
                <p style={{ textAlign: "left" }}>
                  Yes, send me my promo code to save 10% off my next service.
                </p>
              </div>
            </div>
          )}
          <div className="action_button">
            <Button
              fluid
              loading={isSubmitting}
              onClick={onSubmit}
              disabled={
                (!cart.shop && !cart.appointment_date_pretty) ||
                isSubmitting ||
                cart.order_services.length == 0 ||
                (isEbayTireCart && (!mobileNumber || !!mobileNumberError))
              }
              className="primary-button"
            >
              {isEbayTireOrder(cart) ? t("confirmTireInstall") : t("confirmServiceRequest")}
            </Button>
          </div>
        </div>
      ) : (
        <LoadingComponent />
      )}

      <Modal
        className="add-vehicle-modal payment-model"
        onClose={() => setOpenModal(false)}
        onOpen={() => setOpenModal(true)}
        open={openModal}
      >
        <div className="add-vehicle-header">
          <p>Choose your payment method</p>
          <p onClick={() => setOpenModal(false)}>
            <Image src={CloseIcon} alt="close-icon" />
          </p>
        </div>
        <div className="add-payment-content">
          <AddPaymentDetails asModal={true} closeModalHandler={() => setOpenModal(false)} />
        </div>
      </Modal>
    </>
  )
}

function mapStateToProps(state, props) {
  const user = state.user
  let cart
  const braintreePaymentMethods = Array.isArray(state?.paymentMethods?.braintreePaymentMethods)
    ? state.paymentMethods.braintreePaymentMethods.filter((method) => method?.type !== "ach")
    : []
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)
  const order =
    activeVehicle &&
    activeVehicle.id &&
    (user.active_orders || []).find((o) => o.vehicle_id === activeVehicle.id)
  let updatedCartData = getUpdatedCart(user, order, props)
  if (updatedCartData) {
    cart = updatedCartData.cart
  } else {
    cart = user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
  }

  return {
    braintreePaymentMethods: braintreePaymentMethods,
    user: state.user,
    cart: cart,
    vehicle: activeVehicle,
    activeVehicle: activeVehicle,
    order
  }
}

export default withRouter(
  connect(mapStateToProps, {
    createOrder,
    me,
    updateOrder,
    optInForMarketing,
    updateInfo
  })(withTranslation("serviceRequest")(ReviewRequest))
)
